<template>
  <div class="columnManage">
    <div class="columnManage-main">
      <!-- 查询框 v1.8.1- -->
      <div class="columnManage-main-contain">
        <el-table
          v-loading="propsTable.listLoading"
          :data="alldata"
          highlight-current-row
          fit
          border
          element-loading-text="Loading"
          class="list-table"
          :span-method="arraySpanMethod"
        >
          <el-table-column
            label="一级"
            align="center"
            prop="name"
            width="100px"
          />
          <el-table-column label="二级" prop="subname" align="center" />
          <el-table-column label="访问量(次)" prop="pvNum" align="center" />
          <el-table-column
            label="访问时长(小时)"
            prop="askTime"
            align="center"
          />
          <el-table-column label="访问账号(个)" prop="uvNum" align="center" />
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TableList',
  props: {
    tableData: {
      default: Array,
      type: Array
    },
    propsTable: {
      default: Object,
      type: Object
    }
  },
  data() {
    return {
      alldata: []
    };
  },
  watch: {
    tableData: {
      handler(val) {
        if (val) {
          this.alldata = this.handleTableArr(this.tableData);
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.alldata = this.handleTableArr(this.tableData);
  },
  methods: {
    // 解析数据
    handleTableArr(data) {
      const arr = [];
      for (let i = 0; i < data.length; i++) {
        const data_info = data[i];
        const child = data_info['child'];
        let count = 0;
        for (let j = 0; j < child.length; j++) {
          {
            count++;
            const info = {
              // 确定每天数据的 合并行的数量
              name: data_info['name'],
              subname: child[j]['name'],
              pvNum: child[j]['pvNum'],
              askTime: child[j]['askTime'],
              uvNum: child[j]['uvNum']
            };
            arr.push(info);
          }
        }
        // 第一列的合并数量, 赋值给每个大项的第一个单元格. 比如合格积分要合并 8 行.
        arr[arr.length - count]['count'] = count;
      }
      return arr;
    },
    // 表格合并的方法
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 第一列
      if (columnIndex === 0) {
        if (row.count) {
          return [row.count, 1];
        } else {
          return [0, 0];
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.columnManage {
  padding-bottom: 20px;
}

.dialogMain {
  max-height: 470px;
  overflow-y: auto;
}
.edit-form-input {
  width: 150px;
}
// .handle-form-input {
//   // width: 80%;
// }
.el-form-item {
  margin-bottom: 0;
}

.upload-picture {
  float: right;
}
.link {
  color: #409eff;
  text-decoration: underline;
}

.picture-wrapper {
  width: 80%;
  height: 100px;
  margin-top: 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
</style>
